import { useContext } from 'preact/hooks';
import { ICONS } from '../utils/constants.js';
import { ChatContext } from '../hooks/context.js';
import { setOpen } from '../store/chatStore.js';

export function Header({ onNewChat, onHistory }) {
  const { cfg, bus, session } = useContext(ChatContext);

  const handleClose = () => {
    setOpen(false);
    bus.emit('close', { sessionId: session.getOrCreate().sessionId });
  };

  return (
    <header class="mc-header" part="header">
      <div class="mc-avatar-ring">
        <div class="mc-avatar-inner">
          {cfg.botAvatar
            ? <img src={cfg.botAvatar} alt={cfg.botName} loading="lazy" />
            : <span>{cfg.botInitials}</span>
          }
        </div>
      </div>
      <div class="mc-header-info">
        <div class="mc-header-name">{cfg.botName}</div>
        {cfg.showHeaderSubtitle && (
          <div class="mc-header-status">
            <span class="mc-status-dot" />
            <span>{cfg.botStatusText}</span>
          </div>
        )}
      </div>
      <div class="mc-header-actions">
        <button class="mc-hbtn mc-btn-newchat" title="New conversation" aria-label="New conversation"
          onClick={onNewChat} dangerouslySetInnerHTML={{ __html: ICONS.newchat }} />
        <button class="mc-hbtn mc-btn-history" title="Chat history" aria-label="Chat history"
          onClick={onHistory} dangerouslySetInnerHTML={{ __html: ICONS.history }} />
        <button class="mc-hbtn mc-btn-close" title="Close" aria-label="Close"
          onClick={handleClose} dangerouslySetInnerHTML={{ __html: ICONS.close }} />
      </div>
    </header>
  );
}
